/*---------------------------
| Store
---------------------------*/
// Action Types
const actionPrefix = "DropDownContext:";
export const actionTypes = {
    SET_IS_OPEN: `${actionPrefix} setIsOpen`
};

// Reducer
export const reducer = (state, action) => {
    const { type } = action;

    switch (type) {
        case actionTypes.SET_IS_OPEN: {
            return {
                ...state,
                isOpen: action.isOpen,
                shouldFocus: action.shouldFocus
            };
        }
        default: {
            return { ...state };
        }
    }
};
